<div class="d-flex align-self-baseline mt-3">
  <div class="card fitting-cards flex-fill">
    <div *ngIf="showHeader" class="card-header text-center bg-dark bg-gradient text-white"><b>Closure Product Specifications</b></div>

    <div class="card-body">
      <ng-template #loader>
        <app-loader *ngIf="showLoader"></app-loader>
      </ng-template>

      <ng-container *ngIf="!showLoader else loader">
        <div class="d-flex flex-column" *ngIf="!!product">
          <div class="d-flex">
            <ng-container *ngIf="!!hasDrawing">
              <b class="text-nowrap">Product/Part #:</b>
              <a class="cursor-pointer text-tdw ms-auto" (click)="getClosureDrawing.emit(product)">
                <b class="ms-2">{{product.partNumber}}</b>
              </a>
            </ng-container>
            <ng-container *ngIf="!hasDrawing">
              <span>Product/Part&nbsp;#:</span>
              <span class="ms-2 text-tdw ms-auto">{{product.partNumber}}</span>
            </ng-container>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25">Name:</b><span class="ms-auto">{{product.productName}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Description:</b><span class="ms-auto">{{product.description}}</span>
          </div>
          <hr />
          <div class="d-flex flex-wrap">
            <div class="d-flex flex-column w-100">
              <div class="d-flex">
                <b class="w-25 text-nowrap">Diameter:</b><span class="ms-auto">{{product.diameter}}</span>
              </div>
              <div class="d-flex">
                <b class="w-25 text-nowrap">Flanged:</b><span class="ms-auto">{{product.flanged}}</span>
              </div>
              <div class="d-flex" *ngIf="product.flangeClass">
                <b class="w-25 text-nowrap">Flange Class:</b><span class="ms-auto">{{product.flangeClass}}</span>
              </div>
              <div class="d-flex">
                <b class="w-25 text-nowrap">Wall Thickness:</b><span class="ms-auto">{{product.wallThickness}}</span>
              </div>
              <div class="d-flex mx-auto my-3" *ngIf="!!product.image">
                <img style="width: 250px;" [src]="(product.image || '') | imgFromBytes" alt="">
              </div>
              <ng-container *ngIf="additionalDrawings.length > 0">
                <hr class="mb-0" />
                <div class="d-flex"><b class="fs-5 mb-2">Drawings</b></div>
                <div class="d-flex">
                  <button class="btn btn-outline-secondary btn-sm" (click)="getClosureAssociatedDrawing.emit(dwg)" [ngClass]="{'me-2': first, 'mx-2': !first}" *ngFor="let dwg of additionalDrawings; let first=first">{{dwg}}</button>
                </div>
              </ng-container>
              <div class="d-flex">
                <app-replaces-parts [replacedParts]="product.replacedParts"></app-replaces-parts>
              </div>
            </div>
          </div>
          <hr />
          <div class="d-flex flex-wrap mb-3">
            <b class="w-25 text-nowrap">Design Temp:</b><span class="ms-auto">{{product.minDesignTemp}}&nbsp;to&nbsp;{{product.maxDesignTemp}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Hinge Orientation:</b><span class="ms-auto">{{product.hingeOrientation}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Clamp Ring:</b><span class="ms-auto">{{product.clampRing}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Design Codes:</b><span class="ms-auto">{{product.designCodes}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Product Weight:</b><span class="ms-auto">{{product.weight}}</span>
          </div>
          <div class="d-flex flex-wrap">
            <b class="w-25 text-nowrap">Notes:</b><span class="ms-auto">{{product.notes}}</span>
          </div>
          <hr />


          <app-design-pressures [designPressures]="product.designPressures"></app-design-pressures>
          <app-seal-materials [sealMaterials]="product.sealMaterials"></app-seal-materials>
          <app-oring-options [closurePartNumber]="product.partNumber"></app-oring-options>
          <!-- <app-associated-products [products]="product.associatedProducts"
                                   (getFittingAssociatedDrawing)="getFittingAssociatedDrawing.emit($event)">
          </app-associated-products> -->
        </div>
      </ng-container>

    </div>
  </div>
</div>
